import queryString from 'query-string';
import type { IssueTypeResourceData } from '@atlassian/jira-admin-pages-issue-types-common/src/types.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { ERROR_REPORTING_PACKAGE_NAME } from '../../common/constants.tsx';
import { toApiUrlTransformer, fromUrlTransformer } from './utils/transformers.tsx';

export const getIssueTypes = async (qs: string): Promise<IssueTypeResourceData> => {
	const filter = fromUrlTransformer(queryString.parse(qs));
	const query = queryString.stringify(toApiUrlTransformer(filter));

	try {
		return await fetchJson(`/rest/internal/3/issuetype/search?${query}`);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getIssueTypesRequest',
				packageName: ERROR_REPORTING_PACKAGE_NAME,
				teamName: 'morphinecake',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
